import {atom} from 'jotai'
import {Sample} from 'src/feature/dashboard/domain'

const sample: Sample = {
  id: '1',
  name: 'sample',
}

export const sampleAtom = atom<Sample>(sample)
